import type { Guide } from '../types';

/** S-20.10-06 — pulpit planisty FTL (scenariusz e2e 14). */
export const guide: Guide = {
  flagKey: 'plannerDashboard',
  title: 'Pulpit planisty FTL',
  whatItDoes:
    'Ekran startowy planisty FTL. Liczby: moje warianty (czekające, z terminem mijającym dziś, po terminie, w konflikcie), zlecenia do obsadzenia w moim regionie, moje pojazdy wolne, zajęte i bez pozycji, moje powiadomienia i wnioski o odpięcie. „Moje pojazdy” to opiekun FTL wskazany w menu użytkownika. Każda liczba otwiera listę z tym samym filtrem, którym ją policzono.',
  audience: ['planista FTL'],
  presentationItems: ['S-20.10-06'],
  steps: [
    {
      route: '/ftl-planner-dashboard',
      target: 'ftl-planner-scope',
      title: 'Czyje pojazdy liczy pulpit',
      description:
        'Pulpit liczy pojazdy opiekuna wskazanego w menu użytkownika („Jestem opiekunem FTL”). Bez wskazania liczby „moich pojazdów” są puste.',
      action: 'Sprawdź opiekuna; zmienisz go w menu użytkownika.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/ftl-planner-dashboard',
      target: 'ftl-tile-myVariantsActive',
      mockupTestId: 'wsp-ftl',
      title: 'Moje warianty',
      description:
        'Warianty czekające na decyzję Team Leadera; obok — z terminem mijającym dziś, po terminie i w konflikcie w czasie.',
      action: 'Kliknij kafelek, żeby zobaczyć listę zleceń z Twoimi wariantami.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/ftl-planner-dashboard',
      target: 'ftl-tile-myCarsFree',
      title: 'Moje pojazdy',
      description: 'Pojazdy wolne teraz, zajęte teraz i bez znanej pozycji — kafelek otwiera harmonogram floty z tym filtrem.',
      action: 'Kliknij „Wolne teraz”, żeby zobaczyć te pojazdy w harmonogramie floty.',
      recorder: { account: 'ftl' },
    },
  ],
};
